var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "lit", "lit/directives/class-map.js", "lit/decorators.js", "@lit/context", "./app-context", "backbone", "./utils", "./utils/theme", "model/compute_wiring", "model/tree", "model/computed", "utils/url", "utils/trace", "client/client-config", "../../../apps/src/js/api/v2/models/result", "./custom-element-registry", "i18n/i18n", "client/action", "./renderedItems", "../../../apps/src/js/api/v2/models/answer"], function (require, exports, lit_1, class_map_js_1, decorators_js_1, context_1, app_context_1, Backbone, utils_1, theme_1, compute_wiring_1, tree_1, computed_1, url_1, trace_1, client_config_1, result_1, custom_element_registry_1, i18n_1, action_1, renderedItems_1, answer_1) {
    "use strict";
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AnswerLoadingElement = exports.StockIconElement = exports.AnswerSourcesElement = exports.AnswerActionsElement = exports.ResultElement = exports.ResultSnippetElement = exports.ResultContainerElement = void 0;
    Backbone = __importStar(Backbone);
    compute_wiring_1 = __importDefault(compute_wiring_1);
    tree_1 = __importDefault(tree_1);
    computed_1 = __importDefault(computed_1);
    client_config_1 = __importDefault(client_config_1);
    i18n_1 = __importDefault(i18n_1);
    action_1 = __importDefault(action_1);
    /**
     * @element insight-result-container
     */
    class ResultContainerElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.expanded = false;
            this.activeSnippetIndex = 0;
        }
        static get styles() {
            return (0, lit_1.css) `
      :host {
        --result-container-border-width: var(--insight-result-container-border-width);
        --result-container-border-style: var(--insight-result-container-border-style);
        --result-container-border-color: var(--insight-result-container-border-color);
        --result-container-border-radius: var(--insight-result-container-border-radius);
        --result-container-background-color: var(--insight-result-container-background-color);
        --result-snippet-separator-border-width: var(--insight-result-snippet-border-width);
        --result-snippet-separator-border-color: var(--insight-result-snippet-border-color);
        --result-snippet-separator-border-style: var(--insight-result-snippet-border-style);
        --result-snippet-summary-color: var(--insight-result-snippet-summary-color);
        --result-snippet-summary-font-size: var(--insight-result-snippet-summary-font-size);
        --result-snippet-summary-font-weight: var(--insight-result-snippet-summary-font-weight);
        --result-snippet-summary-font-family: var(--insight-result-snippet-summary-font-family);
        --result-snippet-property-label-color: var(--insight-result-snippet-property-label-color);
        --result-snippet-property-label-font-family: var(--insight-result-snippet-property-label-font-family);
        --result-snippet-property-label-font-size: var(--insight-result-snippet-property-label-font-size);
        --result-snippet-property-label-font-weight: var(--insight-result-snippet-property-label-font-weight);
        --result-snippet-property-value-color: var(--insight-result-snippet-property-value-color);
        --result-snippet-property-value-font-family: var(--insight-result-snippet-property-value-font-family);
        --result-snippet-property-value-font-size: var(--insight-result-snippet-property-value-font-size);
        --result-snippet-property-value-font-weight: var(--insight-result-snippet-property-value-font-weight);
      }

      .result-container {
        background: var(--result-container-background-color);
        min-width: 0px;
        max-width: 100%;
        border-width: var(--result-container-border-width);
        border-style: var(--result-container-border-style);
        border-color: var(--result-container-border-color);
        border-radius: var(--result-container-border-radius);
        padding: 12px 15px;
      }

      .result-container.collapsed {
        width: fit-content;
        max-width: 100%;
        border-color: var(--mindbreeze-border-color);
        padding: 0px;
        transition: border-color 0.3s ease;
      }
      .result-container.collapsed:hover {
        border-color: var(--result-container-border-color);
      }

      slot[name="content"] {
        flex: 1;
        min-width: 0;
        max-width: 90%
      }
      
      .btn-collapse-result-container {
        height: fit-content;
        width: fit-content;
        background: none;
        border: none;
        padding: 4px;
        cursor: pointer;
      }
      .result-header{
        display:flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        padding-bottom: 10px;
        border-bottom: var(--result-snippet-separator-border-width) color-mix(in srgb, var(--result-snippet-separator-border-color) 50%, transparent)   var(--result-snippet-separator-border-style);
      }
      .result-snippet-selection-container{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 3px;
        margin-left:-4px;
      }
      .result-snippet-selection-container > span {
        font-size:12px;
      }
      .result-snippet-selection-container.single-source{
        opacity:0.6;
      }
      .result-snippet-back, .result-snippet-forward {
        background: none;
        border: none;
        height: 16px;
        width: 16px;
        font-size: 16px;
        line-height: 16px;
        padding: 0px;
        margin: 0px;
        align-content: center;
        cursor: pointer;
      }
      .result-snippet-back > span,
      .result-snippet-forward > span {
        display: flex;
        justify-content: center;
      }
      .result-snippet-back:disabled, .result-snippet-forward:disabled{
        opacity: 0.2;
        cursor: not-allowed;
      }
      .btn-collapse-result-container  .mb-icon {

        height: 10px;
        width: 10px;
      }
      .result-snippet-back  .mb-icon, .result-snippet-forward  .mb-icon{
        height: 12px;
        width: 12px;
      }
    `;
        }
        connectedCallback() {
            super.connectedCallback();
            if (this.application) {
                // @ts-ignore
                this.ResultElementStylingModel = this.application.getThemeProvider().getWidgetStyling("resultsources");
                if (this.ResultElementStylingModel) {
                    this.ResultElementStylingModel.on('change', () => {
                        this.widgetStyling = Object.assign({}, this.ResultElementStylingModel.attributes);
                        this.requestUpdate();
                    });
                    this.ResultElementStylingModel.trigger('change');
                }
            }
        }
        setThemeDescriptorModel(themeDescriptorModel) {
            this.themeDescriptorModel = themeDescriptorModel;
        }
        requestUpdate(name, oldValue, options) {
            super.requestUpdate(name, oldValue, options);
            if (name === "application" && oldValue == null && this.application) {
                this.setThemeDescriptorModel(this.application.getThemeDescriptorModel());
            }
        }
        _toggleExpand() {
            this.expanded = !this.expanded;
            const event = new CustomEvent('expand-change', {
                bubbles: true,
                composed: true,
                detail: { expanded: this.expanded }
            });
            this.dispatchEvent(event);
        }
        _createNavigationArrows() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const theme = ((_a = this.themeDescriptorModel) === null || _a === void 0 ? void 0 : _a.attributes) || {};
            const icons = theme.icons || {};
            // Previous icon
            const previousIcon = (0, utils_1.renderIcon)(icons, 'arrow-left', {
                color: (0, theme_1.resolveCssVarValue)((_c = (_b = theme.themes) === null || _b === void 0 ? void 0 : _b.base) === null || _c === void 0 ? void 0 : _c.primary, theme) || 'currentColor',
                altText: (0, i18n_1.default)('table_paginate_previous'),
            });
            // Next icon
            const nextIcon = (0, utils_1.renderIcon)(icons, 'arrow-right', {
                color: (0, theme_1.resolveCssVarValue)((_e = (_d = theme.themes) === null || _d === void 0 ? void 0 : _d.base) === null || _e === void 0 ? void 0 : _e.primary, theme) || 'currentColor',
                altText: (0, i18n_1.default)('next'),
            });
            // Close icon
            const closeIcon = (0, utils_1.renderIcon)(icons, 'close-x-icon', {
                color: (0, theme_1.resolveCssVarValue)((_h = (_g = (_f = this.widgetStyling) === null || _f === void 0 ? void 0 : _f.result) === null || _g === void 0 ? void 0 : _g.base) === null || _h === void 0 ? void 0 : _h.closeBtnColor, theme) || 'currentColor',
                altText: (0, i18n_1.default)('Close'),
            });
            return { previousIcon, nextIcon, closeIcon };
        }
        _dispatchSnippetAction(type) {
            this.dispatchEvent(new CustomEvent('snippet-action', {
                bubbles: true,
                composed: true,
                detail: { type }
            }));
        }
        decreaseSnippetIndex() {
            if (this.activeSnippetIndex <= 0) {
                return;
            }
            this._dispatchSnippetAction('DECREASE_SNIPPET_INDEX');
        }
        increaseSnippetIndex() {
            if (this.activeSnippetIndex >= this.snippets.length - 1) {
                return;
            }
            this._dispatchSnippetAction('INCREASE_SNIPPET_INDEX');
        }
        render() {
            var _a, _b, _c, _d;
            const { previousIcon, nextIcon, closeIcon } = this._createNavigationArrows();
            const ApplicationPrefix = (_a = this.application.themeable.prefix) !== null && _a !== void 0 ? _a : '';
            const hideAccentBorder = ((_d = (_c = (_b = this.widgetStyling) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.base) === null || _d === void 0 ? void 0 : _d.hideLeftAccentBorder) || false;
            /**
             *  This is wrong usage of variables - Everything should be overriable
             *  var(--${ApplicationPrefix ? `${ApplicationPrefix}-` : ''}colors-primary) !important;
             */
            return (0, lit_1.html) `${!hideAccentBorder ? (0, lit_1.html) `<style>.result-container { border-left: 3px solid; }</style>` : ""}
                <div class=${(0, class_map_js_1.classMap)({ 'result-container': true, 'collapsed': !this.expanded })}>
                ${this.expanded ? (0, lit_1.html) `
                  <div class="result-header">
                    <div class=${(0, class_map_js_1.classMap)({ "result-snippet-selection-container": true, "single-source": this.snippets.length == 1 })}>
                      <button class="result-snippet-back" ?disabled=${this.activeSnippetIndex == 0} @click="${this.decreaseSnippetIndex}">${previousIcon}</button>
                      <span>${this.activeSnippetIndex + 1} / ${this.snippets.length}</span>
                      <button class="result-snippet-forward" ?disabled=${this.activeSnippetIndex >= this.snippets.length - 1} @click="${this.increaseSnippetIndex}">${nextIcon}</button>
                    </div>
                    <button class="btn-collapse-result-container" @click="${this._toggleExpand}">
                      ${closeIcon}
                    </button>
                  </div>
                  ` : lit_1.nothing}  
                 <slot name="content"></slot>
                </div>`;
        }
    }
    exports.ResultContainerElement = ResultContainerElement;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_a = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _a : Object)
    ], ResultContainerElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean, reflect: true }),
        __metadata("design:type", Boolean)
    ], ResultContainerElement.prototype, "expanded", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Number)
    ], ResultContainerElement.prototype, "activeSnippetIndex", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_b = typeof result_1.ListValue !== "undefined" && result_1.ListValue) === "function" ? _b : Object)
    ], ResultContainerElement.prototype, "snippets", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", typeof (_c = typeof Partial !== "undefined" && Partial) === "function" ? _c : Object)
    ], ResultContainerElement.prototype, "widgetStyling", void 0);
    class ResultSnippetElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.activeSnippetIndex = 0;
            this.collapsed = false;
            this.tooLong = false;
        }
        connectedCallback() {
            super.connectedCallback();
            if (this.application) {
                // @ts-ignore
                this.ResultElementStylingModel = this.application.getThemeProvider().getWidgetStyling("resultsources");
                if (this.ResultElementStylingModel) {
                    this.ResultElementStylingModel.on('change', () => {
                        this.widgetStyling = Object.assign({}, this.ResultElementStylingModel.attributes);
                        this.requestUpdate();
                    });
                    this.ResultElementStylingModel.trigger('change');
                }
            }
        }
        setThemeDescriptorModel(themeDescriptorModel) {
            this.themeDescriptorModel = themeDescriptorModel;
        }
        requestUpdate(name, oldValue, options) {
            super.requestUpdate(name, oldValue, options);
            if (name === "application" && oldValue == null && this.application) {
                this.setThemeDescriptorModel(this.application.getThemeDescriptorModel());
            }
        }
        firstUpdated() {
            this.checkContentHeight();
        }
        updated(changedProperties) {
            this.checkContentHeight();
        }
        static get styles() {
            return (0, lit_1.css) `
        :host {
          --result-snippet-max-lines: var(--insight-result-snippet-max-lines);
        }

        .content.collapse {
          display: -webkit-box;
          -webkit-line-clamp: var(--result-snippet-max-lines);
          -webkit-box-orient: vertical;
          overflow: hidden;
          position: relative;
          /* fade */
          -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
          -webkit-mask-repeat: no-repeat;
          -webkit-mask-size: 100% 100%;
          mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
          mask-repeat: no-repeat;
          mask-size: 100% 100%; 
        }

        .content {
          word-break: break-word;
        }

        .result-snippet-show-more-container {
          width:100%;
          display:flex;
          align-items: center;
          justify-content: flex-start;
        }
        .result-snippet-show-more-container.invisible {
          display: none;
        }

        .result-snippet-show-more-button {
          background: none; 
          border: none;
          text-decoration: underline;
          cursor: pointer;
          padding: 0px;
          padding-top: 5px;
        }
 
      `;
        }
        getCurrentSnippet() {
            var _a;
            const renderer = new result_1.DefaultHTMLRenderer();
            const renderContext = new result_1.RenderContext({ themeDescriptor: this.themeDescriptorModel.attributes });
            // Fallback to the first snippet id if activeSnippetIndex not found
            const currSnippetFound = ((_a = this.snippets.elementValues) === null || _a === void 0 ? void 0 : _a[this.activeSnippetIndex]) || this.snippets.elementValues[0];
            if (currSnippetFound) {
                return this.snippets.elementValues[this.activeSnippetIndex].render(renderContext, renderer);
            }
            return lit_1.nothing;
        }
        render() {
            if (!this.snippets) {
                return lit_1.nothing;
            }
            return (0, lit_1.html) `
        <div class="text-snippet">
            <div class="content ${this.collapsed ? "collapse" : ""}">
              ${this.getCurrentSnippet()}
            </div>
            <div class="result-snippet-show-more-container ${this.tooLong ? "" : "invisible"}" @click="${this.showMoreClicked}">
              <button class="result-snippet-show-more-button">${this.collapsed ? (0, i18n_1.default)("show_more") : (0, i18n_1.default)("show_less")}</button>
            </div>
        </div>
    `;
        }
        showMoreClicked() {
            this.collapsed = !this.collapsed;
        }
        checkContentHeight() {
            var _a, _b, _c;
            const element = this.renderRoot.querySelector('.content');
            element.classList.remove("collapse");
            const linecount = this._calculateLines(element);
            const maxLines = Number((_c = (_b = (_a = this.widgetStyling) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.snippet) === null || _c === void 0 ? void 0 : _c.maxLines);
            if (!maxLines) { // do nothing if maxLines is 0 or not defined
                this.tooLong = false;
                return;
            }
            if (this.tooLong && !this.collapsed) {
                return; // indicates that the button has been pressed 
            }
            if (linecount > maxLines) {
                this.tooLong = true;
                this.collapsed = true;
                element.classList.add("collapse");
            }
            else {
                this.tooLong = false;
                this.collapsed = false;
            }
        }
        _calculateLines(el) {
            const style = window.getComputedStyle(el);
            const lineHeight = parseFloat(style.lineHeight);
            const height = el.clientHeight;
            const lines = Math.round(height / lineHeight);
            return lines;
        }
    }
    exports.ResultSnippetElement = ResultSnippetElement;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_d = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _d : Object)
    ], ResultSnippetElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Number)
    ], ResultSnippetElement.prototype, "activeSnippetIndex", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_e = typeof result_1.ListValue !== "undefined" && result_1.ListValue) === "function" ? _e : Object)
    ], ResultSnippetElement.prototype, "snippets", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], ResultSnippetElement.prototype, "collapsed", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], ResultSnippetElement.prototype, "tooLong", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", typeof (_f = typeof Partial !== "undefined" && Partial) === "function" ? _f : Object)
    ], ResultSnippetElement.prototype, "widgetStyling", void 0);
    /**
     * @element insight-result
     */
    class ResultElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.events = Object.assign({}, Backbone.Events);
            this.total = 0;
            this.activeSnippetOffset = 0;
            this.expanded = true;
            this.onViewCreate = (modelHolder, options) => {
                this.modelHolder = modelHolder;
                this.events.listenTo(this.modelHolder.model, "change", this.onModelChange.bind(this));
                this.onModelChange(this.modelHolder.model);
            };
            this.getDisplayedProperties = () => {
                return {
                    content: {
                        format: "HTML"
                    },
                    title: {
                        formats: ["HTML", "VALUE"]
                    },
                    "mes:date": {
                        formats: ["HTML", "VALUE"]
                    },
                    actions: {
                        format: "PROPERTY"
                    },
                    "mes:summary": {
                        format: "PROPERTY"
                    }
                };
            };
            this.onViewRemove = () => {
                this.events.stopListening(this.modelHolder.model);
                this.modelHolder = null;
                this.ResultElementStylingModel.destroy();
            };
        }
        firstUpdated(changedProperties) {
            super.firstUpdated(changedProperties);
        }
        onModelChange(model) {
            if ("output" in model && "properties" in model.output) {
                this.result = (0, result_1.createResultPropertiesFromPropertiesModel)(model.output);
                this.model = model;
            }
        }
        static get styles() {
            return (0, lit_1.css) `
      :host {
        --result-source-title-color: var(--insight-sources-index-color);
        --result-source-title-font-size: var(--insight-sources-index-font-size);
        --result-actions-color: var(--insight-result-actions-color);
        --result-actions-hover-color: var(--insight-result-actions-hover-color);
        --result-actions-font-family: var(--insight-result-actions-font-family);
        --result-actions-font-size: var(--insight-result-actions-font-size);
        --result-actions-font-weight: var(--insight-result-actions-font-weight);
        --result-actions-separator-color: var(--insight-result-actions-separator-color);
        --result-actions-separator-width: var(--insight-result-actions-separator-width);
        --result-actions-separator-height: var(--insight-result-actions-separator-height);
       
      }

      insight-result-container {
        flex: 1;
        min-width: 0;
      }

      div[slot="content"] {
        min-width: 0;
        width: 100%;
        max-width: 100%;
      }

      div[slot="icon"] > .mb-icon {
        width: 16px;
        height: 16px;
      }

      .resource-container{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap:8px;
        margin-top: 10px;
      }
      .resource-container.expanded{
        align-items: flex-start;
      }
      .resource-container.expanded .resource-index{
        padding-top: 12px;
      }

      .resource-index{
        font-size: var(--result-source-title-font-size);
        color: var(--result-source-title-color);
        min-width: var(--resource-index-min-width);
        text-align: left;
      }
      .result-expanded{
        flex-grow: 1;
      }
      .result-expanded div[slot="content"] {
        box-sizing: border-box;
      }

      .result-collapsed div[slot="title"] {
        font-size: 14px;
        margin: 0px;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      }

      
      
      .result-expanded div[slot="title"]{
        overflow-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
      }

      .result-actions a {
        text-decoration: none;
        font-weight: bold;
        color: var(--result-actions-color);
        cursor: pointer;
        font-family: var(--result-actions-font-family);
        font-size: var(--result-actions-font-size);
        font-weight: var(--result-actions-font-weight)
      }
      
      .result-actions a:hover {
        color: var(--result-actions-hover-color);
      }
      
      .result-actions .action-separator {
        font-weight: bold;
        margin-left: 2px;
        margin-right: 2px;
        height: var(--result-actions-separator-height);
        width: var(--result-actions-separator-width);
        margin: 0 8px;
        background: var(--result-actions-separator-color);
        display:inline-block;
      }

      .result-summary {
        color: var(--result-snippet-summary-color);
        font-size: var(--result-snippet-summary-font-size);
        font-weight: var(--result-snippet-summary-font-weight);
        font-family: var(--result-snippet-summary-font-family)
      }
      .result-summary .property-label{
        color: var(--result-snippet-property-label-color);
        font-weight: var(--result-snippet-property-label-font-weight);
        font-size: var(--result-snippet-property-label-font-size);
        font-family: var(--result-snippet-property-label-font-family);
      }

      .result-summary .property-value{
        color: var(--result-snippet-property-value-color);
        font-weight: var(--result-snippet-property-value-font-weight);
        font-size: var(--result-snippet-property-value-font-size);
        font-family: var(--result-snippet-property-value-font-family);
      }
      .result-summary .property-value em {
        font-weight: bold;
        font-style: normal;
      }

      insight-result-title [slot="title"] em {
        font-style: normal !important;
      }
    `;
        }
        setThemeDescriptorModel(themeDescriptorModel) {
            this.themeDescriptorModel = themeDescriptorModel;
        }
        requestUpdate(name, oldValue, options) {
            if (name === "application" && oldValue == null && this.application) {
                this.setThemeDescriptorModel(this.application.getThemeDescriptorModel());
            }
            super.requestUpdate(name, oldValue, options);
        }
        updated(changedProperties) {
            var _a;
            super.updated(changedProperties);
            if (changedProperties.has('total')) {
                if (this.total > 9) {
                    this.style.setProperty('--resource-index-min-width', (_a = this.widgetStyling.sources.sourceIndexMinWidth) !== null && _a !== void 0 ? _a : "30px");
                }
            }
        }
        connectedCallback() {
            super.connectedCallback();
            if (this.application) {
                // @ts-ignore
                this.ResultElementStylingModel = this.application.getThemeProvider().getWidgetStyling("resultsources");
                if (this.ResultElementStylingModel) {
                    this.ResultElementStylingModel.on('change', () => {
                        this.widgetStyling = Object.assign({}, this.ResultElementStylingModel.attributes);
                        this.requestUpdate();
                    });
                    this.ResultElementStylingModel.trigger('change');
                }
            }
        }
        // Parse"[1]" or "[1.2]" as [1] or [1, 2]
        _getParsedCitationText(text) {
            //
            if (typeof text !== 'string')
                return [];
            const match = text.match(/^\[(.*?)\]$/);
            if (!match)
                return [];
            // Split by dot and convert to numbers
            return match[1]
                .split('.')
                .filter(Boolean)
                .map((n) => Number(n));
        }
        renderActions() {
            var _a, _b, _c;
            let currentSnippet = this.activeSnippetOffset !== undefined ? (_b = (_a = this.result) === null || _a === void 0 ? void 0 : _a.textsnippets) === null || _b === void 0 ? void 0 : _b.value[this.activeSnippetOffset] : undefined;
            let actions = (_c = this.result) === null || _c === void 0 ? void 0 : _c.actions;
            if (!actions) {
                return lit_1.nothing;
            }
            class Renderer extends result_1.DefaultHTMLRenderer {
                constructor(currentSnippet) {
                    super();
                    this.currentSnippet = currentSnippet;
                }
                renderList(context, list, elementType) {
                    if (elementType == result_1.ValueTypeName.NamedAction) {
                        context = context.copyWithOptions({ forceRerenderValue: true });
                    }
                    return super.renderList(context, list, elementType);
                }
                renderNamedAction(context, action) {
                    // @ts-ignore
                    if (result_1.ValueTypeName.Action == action.valueType && "preview" in action.action) {
                        const highlighingOption = {
                            text_fragment: {
                                text: currentSnippet.textsnippet.text_region.text,
                                text_end: currentSnippet.textsnippet.text_region.context_after,
                                text_start: currentSnippet.textsnippet.text_region.context_before,
                            },
                            text_region: {
                                start_position: currentSnippet.textsnippet.text_region.text_start_pos,
                                end_position: currentSnippet.textsnippet.text_region.text_end_pos
                            },
                            is_current: false
                        };
                        const extendedPreviewProps = Object.assign({}, action.action.preview, {
                            highlighting: highlighingOption
                        });
                        action.action.preview = extendedPreviewProps;
                    }
                    // @ts-ignore
                    else if (action.valueType === result_1.ValueTypeName.Link && "href" in action && currentSnippet.textsnippet.property_name === "content" && action.href.includes('#:~:text=')) {
                        // Replace highlighting text
                        const textFragmentHashLink = (0, url_1.makeTextFragmentHashLink)(currentSnippet.textsnippet.text_region.text);
                        action.href = action.href.replace(/(#:~:text=)[^&]*/, "$1" + textFragmentHashLink);
                    }
                    return super.renderNamedAction(context, action);
                }
            }
            const renderer = new Renderer(currentSnippet);
            const renderContext = new result_1.RenderContext();
            // we also want to access the prerendered value.
            return (0, lit_1.html) `<div @click=${this._handleActionClick}>${actions.renderValue(renderContext, renderer)}</div>`;
        }
        _handleActionClick(e) {
            const target = e.target;
            if (target.hasAttribute('data-action-object') || target.hasAttribute('href')) {
                //const action = target.getAttribute('data-action-object');
                // FIXME: Mimic the model.output and model.input
                if (!this.modelHolder || !this.modelHolder.model) {
                    const wiring = new compute_wiring_1.default(new tree_1.default(), this.model);
                    const computedModel = new computed_1.default(wiring, { input: wiring.input, output: this.model });
                    this.modelHolder = {
                        model: computedModel
                    };
                }
                action_1.default.handleActionInstrumented.call(this, e, this.application, this.modelHolder.model, document.activeElement, target);
                e.preventDefault();
            }
        }
        _handleCustomAction(e, actionObject, traceContext) {
            if (!actionObject) {
                console.warn("Unable to handle 'click' action: unknown action object provided.", e);
                return;
            }
            ;
            let actionJson = {};
            if (/string/i.test(typeof actionObject)) {
                actionJson = JSON.parse(actionObject);
            }
            try {
                for (const [actionName, args] of Object.entries(actionJson)) {
                    const focused = !!document.activeElement;
                    // @ts-ignore
                    this.application.handleAction(args, actionName, e.target, this.modelHolder.model, this, focused, traceContext, e);
                }
            }
            catch (e) {
                console.error("Failed to execute action", actionObject, e instanceof Error ? e.stack : e);
            }
        }
        renderSummary() {
            var _a;
            let summary = this.result["mes:summary"];
            let metadataKeys;
            let customMetadata = {};
            // simialar mes:summary 
            if (this.metadataKeys != null) {
                for (const key of this.metadataKeys) {
                    // @ts-ignore
                    const foundProperty = this.result[key];
                    if (foundProperty) {
                        customMetadata[key] = foundProperty;
                    }
                }
                const recordValue = new result_1.RecordValue(customMetadata);
                summary = new result_1.ResultProperty({ key: "mes:summary", label: "", value: recordValue });
            }
            class Renderer extends result_1.DefaultHTMLRenderer {
            }
            const renderer = new Renderer();
            const renderContext = new result_1.RenderContext();
            // we also want to access the prerendered value.
            return (0, lit_1.html) `<div><span class="property-value">${(_a = this.result["mes:date"]) === null || _a === void 0 ? void 0 : _a.renderValue(renderContext, renderer)}</span> ${summary ? summary.renderValue(renderContext, renderer) : lit_1.nothing}</div>`;
        }
        handleTitleClick() {
            var _a;
            if (this.expanded) {
            }
            else {
                this.expanded = true;
            }
            const autoCollapseNonFocued = !!((_a = this.widgetStyling) === null || _a === void 0 ? void 0 : _a.sources.autoCollapseNonFocused);
            if (autoCollapseNonFocued) {
                const collapseEvent = new CustomEvent('autoCollapseNonFocued-request', {
                    bubbles: true,
                    composed: true,
                    detail: { index: this.index }
                });
                this.dispatchEvent(collapseEvent);
            }
        }
        renderVariables() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32;
            let themeDescriptor = this.themeDescriptorModel.attributes;
            if (!((_a = themeDescriptor === null || themeDescriptor === void 0 ? void 0 : themeDescriptor.widgets) === null || _a === void 0 ? void 0 : _a.resultsources)) {
                return "";
            }
            const ApplicationPrefix = (_b = this.application.themeable.prefix) !== null && _b !== void 0 ? _b : '';
            const prefix = "";
            const resultTheme = (_c = this.widgetStyling) === null || _c === void 0 ? void 0 : _c.result;
            const resultSourcesTheme = (_d = this.widgetStyling) === null || _d === void 0 ? void 0 : _d.sources;
            return (0, lit_1.html) `<style> 
                :host {
                  --insight-result-container-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.base.border.color)}; 
                  --insight-result-container-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.base.border.width)};
                  --insight-result-container-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.base.border.style)};
                  --insight-result-container-border-radius: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.base.borderRadius)};
                  --insight-result-container-background-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.base.backgroundColor)};
                  --insight-result-title-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.title.color)}; 
                  --insight-result-title-font-family: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.title.font.family)};
                  --insight-result-title-font-size: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.title.font.size)};
                  --insight-result-title-font-weight: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.title.font.weight)};
                  --insight-result-title-line-height: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.title.lineHeight)};
                  --insight-result-snippet-max-lines: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.snippet.maxLines)};
                  --insight-result-snippet-border-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.snippet.border.color)};
                  --insight-result-snippet-border-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.snippet.border.width)};
                  --insight-result-snippet-border-style: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.snippet.border.style)};
                  --insight-result-snippet-summary-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_f = (_e = resultTheme.snippet) === null || _e === void 0 ? void 0 : _e.summary) === null || _f === void 0 ? void 0 : _f.color)};
                  --insight-result-snippet-summary-font-size: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_j = (_h = (_g = resultTheme.snippet) === null || _g === void 0 ? void 0 : _g.summary) === null || _h === void 0 ? void 0 : _h.font) === null || _j === void 0 ? void 0 : _j.size)};
                  --insight-result-snippet-summary-font-weight: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_m = (_l = (_k = resultTheme.snippet) === null || _k === void 0 ? void 0 : _k.summary) === null || _l === void 0 ? void 0 : _l.font) === null || _m === void 0 ? void 0 : _m.weight)};
                  --insight-result-snippet-summary-font-family: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_q = (_p = (_o = resultTheme.snippet) === null || _o === void 0 ? void 0 : _o.summary) === null || _p === void 0 ? void 0 : _p.font) === null || _q === void 0 ? void 0 : _q.family)};

                  --insight-result-snippet-property-label-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_t = (_s = (_r = resultTheme.snippet) === null || _r === void 0 ? void 0 : _r.property) === null || _s === void 0 ? void 0 : _s.label) === null || _t === void 0 ? void 0 : _t.color)};
                  --insight-result-snippet-property-label-font-size: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_x = (_w = (_v = (_u = resultTheme.snippet) === null || _u === void 0 ? void 0 : _u.property) === null || _v === void 0 ? void 0 : _v.label) === null || _w === void 0 ? void 0 : _w.font) === null || _x === void 0 ? void 0 : _x.size)};
                  --insight-result-snippet-property-label-font-family: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_1 = (_0 = (_z = (_y = resultTheme.snippet) === null || _y === void 0 ? void 0 : _y.property) === null || _z === void 0 ? void 0 : _z.label) === null || _0 === void 0 ? void 0 : _0.font) === null || _1 === void 0 ? void 0 : _1.family)};
                  --insight-result-snippet-property-label-font-weight: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_5 = (_4 = (_3 = (_2 = resultTheme.snippet) === null || _2 === void 0 ? void 0 : _2.property) === null || _3 === void 0 ? void 0 : _3.label) === null || _4 === void 0 ? void 0 : _4.font) === null || _5 === void 0 ? void 0 : _5.weight)};
                  --insight-result-snippet-property-value-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_8 = (_7 = (_6 = resultTheme.snippet) === null || _6 === void 0 ? void 0 : _6.property) === null || _7 === void 0 ? void 0 : _7.value) === null || _8 === void 0 ? void 0 : _8.color)};
                  --insight-result-snippet-property-value-font-family: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_12 = (_11 = (_10 = (_9 = resultTheme.snippet) === null || _9 === void 0 ? void 0 : _9.property) === null || _10 === void 0 ? void 0 : _10.value) === null || _11 === void 0 ? void 0 : _11.font) === null || _12 === void 0 ? void 0 : _12.family)};
                  --insight-result-snippet-property-value-font-size: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_16 = (_15 = (_14 = (_13 = resultTheme.snippet) === null || _13 === void 0 ? void 0 : _13.property) === null || _14 === void 0 ? void 0 : _14.value) === null || _15 === void 0 ? void 0 : _15.font) === null || _16 === void 0 ? void 0 : _16.size)};
                  --insight-result-snippet-property-value-font-weight: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_20 = (_19 = (_18 = (_17 = resultTheme.snippet) === null || _17 === void 0 ? void 0 : _17.property) === null || _18 === void 0 ? void 0 : _18.value) === null || _19 === void 0 ? void 0 : _19.font) === null || _20 === void 0 ? void 0 : _20.weight)};

                  --insight-result-actions-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.actions.color)};
                  --insight-result-actions-font-family: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_22 = (_21 = resultTheme.actions) === null || _21 === void 0 ? void 0 : _21.font) === null || _22 === void 0 ? void 0 : _22.family)};
                  --insight-result-actions-font-weight: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_24 = (_23 = resultTheme.actions) === null || _23 === void 0 ? void 0 : _23.font) === null || _24 === void 0 ? void 0 : _24.weight)};
                  --insight-result-actions-font-size: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_26 = (_25 = resultTheme.actions) === null || _25 === void 0 ? void 0 : _25.font) === null || _26 === void 0 ? void 0 : _26.size)};
                  --insight-result-actions-hover-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultTheme.actions.hoverColor)};
                  --insight-result-actions-separator-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_28 = (_27 = resultTheme.actions) === null || _27 === void 0 ? void 0 : _27.separator) === null || _28 === void 0 ? void 0 : _28.color)};
                  --insight-result-actions-separator-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_30 = (_29 = resultTheme.actions) === null || _29 === void 0 ? void 0 : _29.separator) === null || _30 === void 0 ? void 0 : _30.width)};
                  --insight-result-actions-separator-height: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, (_32 = (_31 = resultTheme.actions) === null || _31 === void 0 ? void 0 : _31.separator) === null || _32 === void 0 ? void 0 : _32.height)};

                  --insight-sources-index-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultSourcesTheme.color)};
                  --insight-sources-index-font-size: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultSourcesTheme.fontSize)};
                  --insight-sources-index-min-width: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, resultSourcesTheme.sourceIndexMinWidth)};
                }
                </style>`;
        }
        shouldShowSourceIndex() {
            var _a;
            const resultsources = (_a = this.widgetStyling) === null || _a === void 0 ? void 0 : _a.sources;
            return !!(resultsources === null || resultsources === void 0 ? void 0 : resultsources.showIndex);
        }
        _handleSnippetAction(e) {
            var _a, _b, _c;
            const { type } = e.detail;
            switch (type) {
                case 'DECREASE_SNIPPET_INDEX':
                    if (this.activeSnippetOffset > 0)
                        this.activeSnippetOffset--;
                    break;
                case 'INCREASE_SNIPPET_INDEX':
                    if (this.activeSnippetOffset < ((_c = (_b = (_a = this.result) === null || _a === void 0 ? void 0 : _a.textsnippets) === null || _b === void 0 ? void 0 : _b.accessor) !== null && _c !== void 0 ? _c : []).length - 1)
                        this.activeSnippetOffset++;
                    break;
            }
            this.requestUpdate();
        }
        getSourceDataIcon() {
            var _a, _b, _c, _d, _e, _f;
            if ((_b = (_a = this.widgetStyling) === null || _a === void 0 ? void 0 : _a.sources) === null || _b === void 0 ? void 0 : _b.hideDataSourceIcon) {
                return lit_1.nothing;
            }
            const theme = ((_c = this.themeDescriptorModel) === null || _c === void 0 ? void 0 : _c.attributes) || {};
            const icons = theme.icons || {};
            let iconEl;
            if (((_d = this.result) === null || _d === void 0 ? void 0 : _d.icon) && this.result.icon.value.rel === "image icon") {
                iconEl = (0, lit_1.html) `<img src="${this.result.icon.value.href}" alt="${(0, i18n_1.default)("icon")}" class="mb-icon" aria-hidden="true">`;
            }
            else {
                const iconData = icons["data-source-default-icon"];
                if (!iconData) {
                    console.warn('Default icon not found in theme');
                    return lit_1.nothing;
                }
                const defaultColor = (0, theme_1.resolveCssVarValue)((_f = (_e = this.widgetStyling) === null || _e === void 0 ? void 0 : _e.sources) === null || _f === void 0 ? void 0 : _f.defaulIconColor, theme) || 'currentColor';
                const iconOptions = {
                    color: String(defaultColor),
                    altText: (0, i18n_1.default)("icon")
                };
                iconEl = new utils_1.Icon(iconData).render(iconOptions);
            }
            return (0, lit_1.html) `<div slot="icon" aria-hidden="true">${iconEl}</div>`;
        }
        // TODO extract the properties
        render() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (!this.result) {
                return;
            }
            class Renderer extends result_1.DefaultHTMLRenderer {
            }
            const renderer = new Renderer();
            const renderContext = new result_1.RenderContext();
            const showResourcesIndex = this.shouldShowSourceIndex();
            return (0, lit_1.html) `${this.renderVariables()}
      <div class=${(0, class_map_js_1.classMap)({ 'resource-container': true, 'expanded': this.expanded })}>
        ${showResourcesIndex ? (0, lit_1.html) `<span class="resource-index">[${this.index}]</span>` : null}
        <insight-result-container class="${this.expanded ? "result-expanded" : "result-collapsed"}" 
          .activeSnippetIndex="${this.activeSnippetOffset}" 
          .snippets=${(_b = (_a = this.result) === null || _a === void 0 ? void 0 : _a.textsnippets) === null || _b === void 0 ? void 0 : _b.accessor}
          .expanded="${this.expanded}" 
          @expand-change="${(e) => { this.expanded = e.detail.expanded; }}"
          @snippet-action="${this._handleSnippetAction}"
        >
          <div slot="content">  
              <insight-result-title @click="${this.handleTitleClick}" .expanded=${this.expanded} .hideIcon=${(_e = (_d = (_c = this.widgetStyling) === null || _c === void 0 ? void 0 : _c.sources) === null || _d === void 0 ? void 0 : _d.hideDataSourceIcon) !== null && _e !== void 0 ? _e : false}>
                  ${this.getSourceDataIcon()}
                <div slot="title">${(_g = (_f = this.result) === null || _f === void 0 ? void 0 : _f.title) === null || _g === void 0 ? void 0 : _g.renderValue(renderContext, renderer)}</div>
              </insight-result-title>
            ${this.expanded ? (0, lit_1.html) `
                <div class="result-actions">${this.renderActions()}</div>
                <div class="result-summary">${this.renderSummary()}</div>

              <div><insight-result-snippet .activeSnippetIndex="${this.activeSnippetOffset}" .snippets=${(_j = (_h = this.result) === null || _h === void 0 ? void 0 : _h.textsnippets) === null || _j === void 0 ? void 0 : _j.accessor}></insight-result-snippet></div>
            ` : lit_1.nothing}
          </div>
        </insight-result-container>
      </div>
    `;
        }
    }
    exports.ResultElement = ResultElement;
    __decorate([
        (0, decorators_js_1.property)({ attribute: true }),
        __metadata("design:type", String)
    ], ResultElement.prototype, "index", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: true }),
        __metadata("design:type", Array)
    ], ResultElement.prototype, "metadataKeys", void 0);
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_g = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _g : Object)
    ], ResultElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", typeof (_h = typeof Partial !== "undefined" && Partial) === "function" ? _h : Object)
    ], ResultElement.prototype, "widgetStyling", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: true }),
        __metadata("design:type", Number)
    ], ResultElement.prototype, "total", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_j = typeof ModelHolder !== "undefined" && ModelHolder) === "function" ? _j : Object)
    ], ResultElement.prototype, "modelHolder", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_k = typeof result_1.ResultProperties !== "undefined" && result_1.ResultProperties) === "function" ? _k : Object)
    ], ResultElement.prototype, "result", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ResultElement.prototype, "model", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Number)
    ], ResultElement.prototype, "activeSnippetOffset", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean, reflect: true }),
        __metadata("design:type", Boolean)
    ], ResultElement.prototype, "expanded", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ResultElement.prototype, "onViewCreate", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ResultElement.prototype, "getDisplayedProperties", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], ResultElement.prototype, "onViewRemove", void 0);
    /**
     * @element insight-result-title
     */
    class ResultTitleElement extends lit_1.LitElement {
        constructor() {
            super(...arguments);
            this.expanded = false;
            this.hideIcon = false;
        }
        static get styles() {
            return (0, lit_1.css) `
      :host{
        --result-title-font-family: var(--insight-result-title-font-family);
        --result-title-font-size: var(--insight-result-title-font-size);
        --result-title-font-weight: var(--insight-result-title-font-weight);
        --result-title-lineHeight: var(--insight-result-title-line-height);
        --result-title-color: var(--insight-result-title-color);
      }
      
      :host:has(.result-title.collapsed){
        cursor: pointer;
      }

      .result-title {
        color: var(--result-title-color);
        font-family: var(--result-title-font-family);
        font-weight: var(--result-title-font-weight);
      }
      .result-title.collapsed {
        display: flex;
        flex-direction: row;
        justify-content: flex-start; 
        align-items: center;
        max-height: 24px;
        max-width: 100%;
        padding: 4px 12px;
      }

      h2 {
        font-size: var(--result-title-font-size);
        font-weight: var(--result-title-font-weight);
        line-height: var(--result-title-line-height);
      }

      .result-title.collapsed > h2 {
        font-size: 14px;
        margin: 0px;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      }

      ::slotted([slot="title"]) {
        all: unset;
        font-style: normal !important;
      }
      
      .result-title.expanded > h2 {
        margin-top: 0px;
        margin-bottom: 2px;
        overflow: clip;
      }

      .result-title.expanded > .result-icon {
        display: none;
      }

      .result-icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      .result-icon:not(::slotted(*)) {
        display: none;
      }
    `;
        }
        connectedCallback() {
            super.connectedCallback();
        }
        handleTitleClick() {
            const event = new CustomEvent('click', {
                bubbles: true,
                composed: true,
                detail: {}
            });
            this.dispatchEvent(event);
        }
        render() {
            return (0, lit_1.html) `
      <div class="result-title ${this.expanded ? "expanded" : "collapsed"}">
        ${!this.hideIcon ? (0, lit_1.html) `<div class="result-icon"><slot name="icon"></slot></div>` : lit_1.nothing}
        <h2 @click="${this.handleTitleClick}"><slot name="title"></slot></h2>
      </div>
    `;
        }
    }
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean, reflect: true }),
        __metadata("design:type", Boolean)
    ], ResultTitleElement.prototype, "expanded", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean }),
        __metadata("design:type", Object)
    ], ResultTitleElement.prototype, "hideIcon", void 0);
    class AnswerActionsElement extends lit_1.LitElement {
        get modelHolder() {
            return this._modelHolder;
        }
        set modelHolder(value) {
            const oldValue = this._modelHolder;
            this._modelHolder = value;
            if (oldValue == null && value != oldValue) {
                this.events.listenTo(this.modelHolder.model.output, "change", this.onModelChange.bind(this));
                this.events.listenTo(this.modelHolder.model.output, "change:computing", this.handleStreaming.bind(this));
                this.events.listenTo(this.modelHolder.model, "expand-sources", this.handleExpandSourcesChange.bind(this));
                this.onModelChange(this.modelHolder.model);
            }
            this.requestUpdate('modelHolder', oldValue);
        }
        constructor() {
            super();
            this.events = Object.assign({}, Backbone.Events);
            this.isSourcesExpanded = false;
            this.sources = [];
            this.isStreaming = false;
            this.onViewCreate = (modelHolder, options) => {
                this.modelHolder = modelHolder;
            };
            this.onViewRemove = (options) => {
                var _a;
                this.events.stopListening();
                (_a = this.actionsElementStylingModel) === null || _a === void 0 ? void 0 : _a.destroy();
            };
            this._handleCopyAnswer = this._handleCopyAnswer.bind(this);
            this._handleRegenerateAnswer = this._handleRegenerateAnswer.bind(this);
            this._handleFeedback = this._handleFeedback.bind(this);
        }
        static get styles() {
            return (0, lit_1.css) `
    :host{
      --display-regenerate-button: var(--mindbreeze-answer-regenerate-button);
      --answer-actions-color: var(--insight-answer-actions-color);
      --answer-actions-hover-color: var(--insight-answer-actions-hover-color);
    }
    .result-resources {
      padding: 0px 16px 0px 16px;
    }
    .mb-action-regenerate-answer{
      display: var(--display-regenerate-button)
    }
    .mb-answer-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--result-sources-actions-color)
    }
    .mb-answer-actions .btn-link {
      padding: 6px;
      color:  var(--insight-answer-actions-color);
      cursor: pointer;
      background: transparent;
      border: none;
      padding-bottom: 0px !important;
    }
    .mb-answer-actions .btn-link:last-child{
      padding-right: 0;
    }
    .mb-answer-actions .additional-sources-label {
      border: none;
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-left: 0px !important;
      padding-bottom: 0px !important;
      gap: 4px;
    }
    .mb-answer-right {
      display: flex;
    }
    .btn-link:hover{
      text-decoration: none;
      color:  var(--insight-answer-actions-hover-color);
    }
    .btn:focus {
      outline: none;
    }
    `;
        }
        renderVariables() {
            var _a, _b;
            let themeDescriptor = this.actionsElementStylingModel.attributes;
            if (!(themeDescriptor === null || themeDescriptor === void 0 ? void 0 : themeDescriptor.actions)) {
                return "";
            }
            const ApplicationPrefix = (_a = this.application.themeable.prefix) !== null && _a !== void 0 ? _a : '';
            const prefix = "";
            const actionsTheme = (_b = this.widgetStyling) === null || _b === void 0 ? void 0 : _b.actions;
            return (0, lit_1.html) `<style> 
                :host {
                  --insight-answer-actions-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, actionsTheme.color)}; 
                  --insight-answer-actions-hover-color: ${(0, theme_1.makeCssVarValue)(ApplicationPrefix, prefix, actionsTheme.hoverColor)};
                }
                </style>`;
        }
        onModelChange(model) {
            let sources = model.get("sources");
            if (sources && sources.results) {
                this.sources = sources.results;
            }
            else {
                this.sources = [];
            }
            this._setIsSourcesExpandedValue(false);
        }
        firstUpdated(_changedProperties) {
            var _a, _b;
            //@ts-ignore
            this.modeListModel = (_b = (_a = this.application) === null || _a === void 0 ? void 0 : _a.themeable) === null || _b === void 0 ? void 0 : _b.modeListModel;
        }
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener('copy-answer', this._handleCopyAnswer);
            this.addEventListener('regenerate-answer', this._handleRegenerateAnswer);
            this.addEventListener('feedback-answer', this._handleFeedback);
            if (this.application) {
                // @ts-ignore
                this.actionsElementStylingModel = this.application.getThemeProvider().getWidgetStyling("answer");
                if (this.actionsElementStylingModel) {
                    this.actionsElementStylingModel.on('change', () => {
                        this.widgetStyling = Object.assign({}, this.actionsElementStylingModel.attributes);
                        this.requestUpdate();
                    });
                    this.actionsElementStylingModel.trigger('change');
                }
            }
        }
        disconnectedCallback() {
            this.removeEventListener('copy-answer', this._handleCopyAnswer);
            this.removeEventListener('regenerate-answer', this._handleRegenerateAnswer);
            this.removeEventListener('feedback-answer', this._handleFeedback);
        }
        get parentStyles() {
            return this.constructor.styles;
        }
        handleExpandSourcesChange(value) {
            this.isSourcesExpanded = value;
        }
        handleStreaming() {
            var _a;
            this.isStreaming = (_a = this.modelHolder.model.get("computing")) !== null && _a !== void 0 ? _a : false;
        }
        _handleCopyAnswer() {
            var _a, _b, _c, _d;
            let text = (_b = (_a = this.modelHolder.model) === null || _a === void 0 ? void 0 : _a.output) === null || _b === void 0 ? void 0 : _b.get('unparsed_generated_text_without_citations');
            if (!text) {
                text = (_d = (_c = this.modelHolder.model) === null || _c === void 0 ? void 0 : _c.output) === null || _d === void 0 ? void 0 : _d.get('unparsed_generated_text');
            }
            this.application.copyContentToClipboard({
                source: "answer",
                type: "text/html",
                content: text
            });
        }
        _handleRegenerateAnswer() {
            var _a, _b, _c;
            (_c = (_b = (_a = this.modelHolder) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.wiring) === null || _c === void 0 ? void 0 : _c.compute();
            this._setIsSourcesExpandedValue(false);
        }
        _handleFeedback() {
            this.modelHolder.model.trigger('feedback-answer', this.modelHolder.model);
            (0, trace_1.feedback)();
            this._setIsSourcesExpandedValue(false);
        }
        _toggleExpand() {
            this._setIsSourcesExpandedValue(!this.isSourcesExpanded);
        }
        _setIsSourcesExpandedValue(value) {
            this.isSourcesExpanded = value;
            this.modelHolder.model.trigger("expand-sources", this.isSourcesExpanded);
        }
        setThemeDescriptorModel(themeDescriptorModel) {
            this.themeDescriptorModel = themeDescriptorModel;
        }
        requestUpdate(name, oldValue, options) {
            if (name === "application" && oldValue == null && this.application) {
                this.setThemeDescriptorModel(this.application.getThemeDescriptorModel());
            }
            super.requestUpdate(name, oldValue, options);
        }
        _createActionIcons() {
            var _a;
            const theme = ((_a = this.themeDescriptorModel) === null || _a === void 0 ? void 0 : _a.attributes) || {};
            const icons = theme.icons || {};
            const fontColor = 'currentColor';
            return {
                copyIcon: (0, utils_1.renderIcon)(icons, 'copy', { color: fontColor }),
                regenerateIcon: (0, utils_1.renderIcon)(icons, 'refresh', { color: fontColor }),
                infoIcon: (0, utils_1.renderIcon)(icons, 'info-sign', { color: fontColor }),
                expandIcon: (0, utils_1.renderIcon)(icons, 'angle-up', { color: fontColor }),
                collapseIcon: (0, utils_1.renderIcon)(icons, 'angle-down', { color: fontColor })
            };
        }
        get getActionsHtml() {
            var _a, _b;
            let fontIconOptions = { color: this.themeDescriptorModel.attributes.themes.base.colors.primary };
            const { copyIcon, regenerateIcon, infoIcon, expandIcon, collapseIcon } = this._createActionIcons();
            // TODO refactor this, per application an not globally
            const telemetryEnabled = !!client_config_1.default.getTelemetryEnabled();
            return !this.isStreaming ? (0, lit_1.html) `<div class="mb-answer-actions">
        <div class="mb-answer-left">
         ${this.sources.length ? (0, lit_1.html) `<button  @click=${() => this._toggleExpand()} class="btn btn-link additional-sources-label" title=${(0, i18n_1.default)("additional_sources")}>
            ${this.sources.length == 1 ? (0, i18n_1.default)('one_source_found') : (0, lit_1.html) `${(0, i18n_1.default)('count_sources_found', [this.sources.length])}`}
            <span>${this.isSourcesExpanded ? expandIcon : collapseIcon}</i></span>
          </button>` : null}
        </div>
        ${!this.hideActions ? (0, lit_1.html) `<div class="mb-answer-right">
          ${((_b = (_a = this.modelHolder) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.get('stream_request_status')) !== answer_1.StreamRequestStatus.RequestFailed ? (0, lit_1.html) `<button
            @click=${() => this.dispatchEvent(new CustomEvent('copy-answer', {
                bubbles: true,
                composed: true
            }))}
            class="btn btn-link mb-action-copy-answer" title=${(0, i18n_1.default)("copy_answer_to_clipboard")}>${copyIcon}<span class="mb-acc"></span>
          </button>` : null}
          <button
            @click=${() => this.dispatchEvent(new CustomEvent('regenerate-answer', {
                bubbles: true,
                composed: true
            }))}
            class="btn btn-link mb-action-regenerate-answer" title=${(0, i18n_1.default)("regenerate_anwser")}>${regenerateIcon}<span class="mb-acc"></span></button>
          <button class="btn btn-link" title=${(0, i18n_1.default)("mindbreeze_answer_generate_info")}>${infoIcon}<span class="mb-acc"></span></button>
          ${telemetryEnabled ? (0, lit_1.html) `<button 
            @click=${() => this.dispatchEvent(new CustomEvent('feedback-answer', {
                bubbles: true,
                composed: true
            }))}
            class="btn btn-link mb-action-feedback-answer" title=${(0, i18n_1.default)("client_headsup_feedback_button")}>${(0, i18n_1.default)("client_headsup_feedback_button")}</button>` : null}
        </div>` : null}
      </div>` : null;
        }
        render() {
            return (0, lit_1.html) `${this.renderVariables()}
      <div>
        <insight-rendered-items 
          .object=${this.getActionsHtml}
          .parentStyles=${this.parentStyles}>
        </insight-rendered-items>
      </div>
    `; //`
        }
    }
    exports.AnswerActionsElement = AnswerActionsElement;
    __decorate([
        (0, decorators_js_1.property)({ attribute: true }),
        __metadata("design:type", Array)
    ], AnswerActionsElement.prototype, "hideActions", void 0);
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_l = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _l : Object)
    ], AnswerActionsElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Boolean)
    ], AnswerActionsElement.prototype, "isSourcesExpanded", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", typeof (_m = typeof Partial !== "undefined" && Partial) === "function" ? _m : Object)
    ], AnswerActionsElement.prototype, "widgetStyling", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_o = typeof Mindbreeze !== "undefined" && Mindbreeze.ModelHolder) === "function" ? _o : Object),
        __metadata("design:paramtypes", [typeof (_p = typeof Mindbreeze !== "undefined" && Mindbreeze.ModelHolder) === "function" ? _p : Object])
    ], AnswerActionsElement.prototype, "modelHolder", null);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Array)
    ], AnswerActionsElement.prototype, "sources", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Boolean)
    ], AnswerActionsElement.prototype, "isStreaming", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], AnswerActionsElement.prototype, "onViewCreate", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], AnswerActionsElement.prototype, "onViewRemove", void 0);
    class AnswerSourcesElement extends lit_1.LitElement {
        get modelHolder() {
            return this._modelHolder;
        }
        set modelHolder(value) {
            const oldValue = this._modelHolder;
            this._modelHolder = value;
            if (oldValue == null && value != oldValue) {
                this.events.listenTo(this.modelHolder.model.output, "change", this.onModelChange.bind(this));
                this.events.listenTo(this.modelHolder.model, "expand-sources", this.handleExpandSourcesChange.bind(this));
                this.onModelChange(this.modelHolder.model);
            }
            this.requestUpdate('modelHolder', oldValue);
        }
        constructor() {
            super();
            this.events = Object.assign({}, Backbone.Events);
            this.isSourcesExpanded = false;
            this.activeSourceIndex = null;
            this.citationMap = {};
            this.onViewCreate = (modelHolder, options) => {
                this.modelHolder = modelHolder;
            };
            this.onViewRemove = (options) => {
                this.events.stopListening();
            };
            this.handleSourceNavigation = (e) => {
                var _a;
                let target = e.target;
                if (target instanceof HTMLAnchorElement && target.href) {
                    const url = new URL(target.href);
                    const citationPattern = /#(?:block-)?citation-id=([\w-]+)/;
                    const citationMatch = url.hash.match(citationPattern);
                    if (citationMatch) {
                        let citationID = citationMatch[1];
                        const entry = this.citationMap[citationID];
                        if (entry) {
                            e.preventDefault();
                            let resultEl = this.renderRoot.querySelector(`insight-result[index="${entry.resultIndex}"]`);
                            if (!this.isSourcesExpanded) {
                                this.expandSources();
                            }
                            this.activeSourceIndex = (_a = resultEl === null || resultEl === void 0 ? void 0 : resultEl.index) !== null && _a !== void 0 ? _a : null;
                            if (resultEl) {
                                if (resultEl instanceof ResultElement) {
                                    resultEl.expanded = true;
                                    resultEl.activeSnippetOffset = entry.snippetOffset;
                                    resultEl.updateComplete.then(() => {
                                        resultEl.scrollIntoView({ behavior: 'smooth' });
                                    });
                                }
                                else {
                                    resultEl.scrollIntoView({ behavior: 'smooth' });
                                }
                            }
                        }
                    }
                }
            };
        }
        onModelChange(model) {
            let sources = model.get("sources");
            if (sources && sources.results) {
                this.citationMap = sources.citation_map;
                this.sources = sources.results;
            }
            else {
                this.sources = [];
            }
            this.isSourcesExpanded = false;
            this.activeSourceIndex = null;
        }
        firstUpdated(_changedProperties) {
            var _a, _b;
            //@ts-ignore
            this.modeListModel = (_b = (_a = this.application) === null || _a === void 0 ? void 0 : _a.themeable) === null || _b === void 0 ? void 0 : _b.modeListModel;
        }
        expandSources() {
            this.isSourcesExpanded = true;
            this.handleExpandSourcesChange(this.isSourcesExpanded);
            this.modelHolder.model.trigger("expand-sources", this.isSourcesExpanded);
        }
        rootDomEl() {
            var _a;
            if ((_a = this.application) === null || _a === void 0 ? void 0 : _a.getRootDomEl()) {
                return this.application.getRootDomEl();
            }
            return document;
        }
        connectedCallback() {
            super.connectedCallback();
            this.rootDomEl().addEventListener("click", this.handleSourceNavigation);
        }
        disconnectedCallback() {
            this.rootDomEl().removeEventListener("click", this.handleSourceNavigation);
        }
        get parentStyles() {
            return this.constructor.styles;
        }
        handleExpandSourcesChange(value) {
            this.isSourcesExpanded = value;
        }
        setThemeDescriptorModel(themeDescriptorModel) {
            this.themeDescriptorModel = themeDescriptorModel;
        }
        requestUpdate(name, oldValue, options) {
            if (name === "application" && oldValue == null && this.application) {
                this.setThemeDescriptorModel(this.application.getThemeDescriptorModel());
            }
            super.requestUpdate(name, oldValue, options);
        }
        handleSelectActiveIndexTab(e) {
            this.activeSourceIndex = e.detail.index;
        }
        render() {
            var _a, _b;
            const total = ((_a = this.sources) === null || _a === void 0 ? void 0 : _a.length) || 0;
            return (0, lit_1.html) `
        <div style="display: ${this.isSourcesExpanded ? "block" : "none"}"> 
          ${(_b = this.sources) === null || _b === void 0 ? void 0 : _b.map(source => (0, lit_1.html) `<insight-result index="${source.resultIndex}"
                                 .total=${total}
                                 .metadataKeys=${this.metadatakeys}
                                 .result=${source.result}
                                 .model=${source.model}
                                 @autoCollapseNonFocued-request="${this.handleSelectActiveIndexTab}"
                                   .expanded=${this.activeSourceIndex == source.resultIndex} >
                </insight-result>`)}
        </div>
    `;
        }
    }
    exports.AnswerSourcesElement = AnswerSourcesElement;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_q = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _q : Object)
    ], AnswerSourcesElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.property)({
            attribute: true,
            converter: {
                fromAttribute: (value) => {
                    if (!value)
                        return undefined;
                    try {
                        return JSON.parse(value);
                    }
                    catch (e) {
                        console.warn('Invalid JSON for metadataKeys:', value);
                        return undefined;
                    }
                },
                toAttribute: (value) => {
                    return value ? JSON.stringify(value) : null;
                },
            },
        }),
        __metadata("design:type", Array)
    ], AnswerSourcesElement.prototype, "metadatakeys", void 0);
    __decorate([
        (0, decorators_js_1.property)({ attribute: true }),
        __metadata("design:type", Boolean)
    ], AnswerSourcesElement.prototype, "isSourcesExpanded", void 0);
    __decorate([
        (0, decorators_js_1.state)(),
        __metadata("design:type", Number)
    ], AnswerSourcesElement.prototype, "activeSourceIndex", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", typeof (_r = typeof Mindbreeze !== "undefined" && Mindbreeze.ModelHolder) === "function" ? _r : Object),
        __metadata("design:paramtypes", [typeof (_s = typeof Mindbreeze !== "undefined" && Mindbreeze.ModelHolder) === "function" ? _s : Object])
    ], AnswerSourcesElement.prototype, "modelHolder", null);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], AnswerSourcesElement.prototype, "citationMap", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Array)
    ], AnswerSourcesElement.prototype, "sources", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], AnswerSourcesElement.prototype, "onViewCreate", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", Object)
    ], AnswerSourcesElement.prototype, "onViewRemove", void 0);
    /**
     * @element insight-stock-icon
     */
    class StockIconElement extends lit_1.LitElement {
        get themeDescriptor() {
            return this.application.getThemeDescriptorModel().attributes;
        }
        render() {
            if (!this.name) {
                return lit_1.nothing;
            }
            const icon = (0, utils_1.renderIcon)(this.themeDescriptor.icons, this.name, {
                color: this.color,
                altText: this.altText,
            });
            return (0, lit_1.html) `
      <span style="
        display: block;
        width: ${this.width}px;
        height: ${this.height}px;
      ">
        ${icon}
      </span>
    `;
        }
    }
    exports.StockIconElement = StockIconElement;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_t = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _t : Object)
    ], StockIconElement.prototype, "application", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", String)
    ], StockIconElement.prototype, "name", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", String)
    ], StockIconElement.prototype, "color", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", String)
    ], StockIconElement.prototype, "altText", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", String)
    ], StockIconElement.prototype, "width", void 0);
    __decorate([
        (0, decorators_js_1.property)(),
        __metadata("design:type", String)
    ], StockIconElement.prototype, "height", void 0);
    /**
     * @element insight-answer-loading
     */
    class AnswerLoadingElement extends lit_1.LitElement {
        get themeDescriptor() {
            return this.application.getThemeDescriptorModel().attributes;
        }
        static get styles() {
            return (0, lit_1.css) `
      .mb-answer-loading {
        display: flex;
        flex: none;
        align-items: center;
        height: 32px;
        gap: 4px;
      }

      .loading-bounce {
        animation: bounce 1s infinite;
        background-color: currentColor;
        height: 4px;
        width: 4px;
        flex: none;
        border-radius: calc(infinity * 1px);
      }

      @keyframes bounce {
        0%, 100% {
          transform: translateY(-25%);
          animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
        }
        50% {
          transform: none;
          animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
        }
      }
    `;
        }
        render() {
            return (0, lit_1.html) `
      <div class="mb-answer-loading flex space-x-1">
        <div class="loading-bounce" style="animation-delay: 0.25s;"></div>
        <div class="loading-bounce" style="animation-delay: 0.5s;"></div>
        <div class="loading-bounce" style="animation-delay: 0.75s;"></div>
      </div>
    `;
        }
    }
    exports.AnswerLoadingElement = AnswerLoadingElement;
    __decorate([
        (0, context_1.consume)({ context: app_context_1.applicationContext, subscribe: true }),
        (0, decorators_js_1.property)({ attribute: false }),
        __metadata("design:type", typeof (_u = typeof Mindbreeze !== "undefined" && Mindbreeze.Application) === "function" ? _u : Object)
    ], AnswerLoadingElement.prototype, "application", void 0);
    custom_element_registry_1.customElementRegistry.register("insight-result-title", ResultTitleElement);
    custom_element_registry_1.customElementRegistry.register("insight-result-container", ResultContainerElement);
    custom_element_registry_1.customElementRegistry.register("insight-result-snippet", ResultSnippetElement);
    custom_element_registry_1.customElementRegistry.register("insight-result", ResultElement);
    custom_element_registry_1.customElementRegistry.register("insight-answer-actions", AnswerActionsElement);
    custom_element_registry_1.customElementRegistry.register("insight-answer-sources", AnswerSourcesElement);
    custom_element_registry_1.customElementRegistry.register("insight-rendered-items", renderedItems_1.InsightRenderedItems);
    custom_element_registry_1.customElementRegistry.register("insight-stock-icon", StockIconElement);
    custom_element_registry_1.customElementRegistry.register("insight-answer-loading", AnswerLoadingElement);
});
